export enum ButtonActionType {
  OpenUrl = 'open-url',
  OpenItem = 'open-item',
  UpdateValue = 'update-value',
  RunAutomation = 'run-automation',
}
